import {isNil, round, sumBy} from 'lodash';
import {Allocation} from 'src/app/domain/model/allocation.model';

export const ALLOCATION_ISIN_CASH = 'CASH';

export interface CustomerPortfolioAllocation extends Allocation {
  isin: string;
  isBridgeFund: boolean;
  expectedPercent: number;
  amount: number;
  performance: number;
  performanceAmount: number;
  diffPercent: number;
  shares: number;
  nav: number;
}

export const isCashAllocation = (allocation: CustomerPortfolioAllocation): boolean => allocation.isin ===
  ALLOCATION_ISIN_CASH;

export const includeUnprocessedCashInAllocations = (
  allocations: CustomerPortfolioAllocation[],
  unprocessedCash: number
): CustomerPortfolioAllocation[] => {
  if (!allocations.some(isCashAllocation)) {
    return allocations;
  }

  const withUnprocessedCash = allocations.map(allocation => isCashAllocation(allocation)
    ? {
      ...allocation,
      amount: round(allocation.amount + unprocessedCash, 2),
      shares: round((allocation.shares ?? 0) + unprocessedCash, 2)
    }
    : allocation);
  const total = round(sumBy(withUnprocessedCash, allocation => allocation.amount), 4);

  return withUnprocessedCash.map(allocation => {
    const percent = total !== 0 ? round(allocation.amount / total * 100, 4) : 0;

    return {
      ...allocation,
      percent,
      diffPercent: isNil(allocation.expectedPercent) ? allocation.diffPercent : percent - allocation.expectedPercent
    };
  });
};
